const isPDP = window.location.pathname.includes("/products/");
if(isPDP) {
  checkPaymentPDP();
}

function checkPaymentPDP(){
 let intervalCount = 0;

  const checkPriceAndRemoveButton = setInterval(() => {
    let price = document.querySelector("#bss-check-payment")?.getAttribute("data-price");
    let priceCP = document.querySelector("#bss-check-payment")?.innerText;
  
    if (price !== null && priceCP !== "" && price.match(/^\d+/)?.[0] !== priceCP.match(/^\d+/)?.[0]) {
      document.querySelector(".product-buy-buttons--smart")?.remove();
      clearInterval(checkPriceAndRemoveButton);
    }
  
    intervalCount += 100;
    if (intervalCount >= 4000) {
      clearInterval(checkPriceAndRemoveButton);
    }
  }, 100);
}

const isCartPage = window.location.pathname.includes("/cart");
if(isCartPage) {
  checkPaymentCart();
}

function checkPaymentCart(){
  let intervalCount = 0;

  const checkPriceAndRemoveButton = setInterval(() => {
    let price = document.querySelector("#bss-check-payment")?.getAttribute("data-price");
    let priceCP = document.querySelector("#bss-check-payment")?.innerText;
  
    if (price !== null && priceCP !== "" && price.match(/^\d+/)?.[0] !== priceCP.match(/^\d+/)?.[0]) {
      document.querySelector(".cart--additional-buttons.additional-checkout-buttons")?.remove();
      clearInterval(checkPriceAndRemoveButton);
    }
  
    intervalCount += 100;
    if (intervalCount >= 4000) {
      clearInterval(checkPriceAndRemoveButton);
    }
  }, 100);
}
